/**
 * useSessionAreaName
 *
 * Returns the current session area name.
 *
 * Resolution order:
 * 1. URL pathname (on AREA / SITE pages that include `:area`)
 * 2. Persisted state via Redux (hydrated from localStorage on startup)
 */
import { useAppSelector } from '@/store/hooks';
import { useLocation } from '@/routing/hooks';
import { getAreaNameFromPath } from '@/routing/lib';
import { selectAreaName } from '@/store/slices/sessionSlice';
export const useSessionAreaName = () => {
    const { pathname } = useLocation();
    const areaFromUrl = getAreaNameFromPath(pathname);
    // Fallback: read from Redux (hydrated from persisted state on startup)
    const areaFromPersistedState = useAppSelector(selectAreaName);
    return areaFromUrl !== null && areaFromUrl !== void 0 ? areaFromUrl : areaFromPersistedState;
};
